import {httpGetPathologies} from '@/features/projects/http/projects.http'
import {ProjectPathology} from '@/features/projects/types'
import {QUERY_KEYS} from '@/queryClient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'

interface UseGetProjectPathologiesOptions {
    urlParams: {
        projectId: string
    }
    options?: Omit<UseQueryOptions<ProjectPathology[]>, 'queryKey' | 'queryFn'>
}

export const useGetProjectPathologies = ({urlParams, options}: UseGetProjectPathologiesOptions) =>
    useQuery({
        queryKey: [QUERY_KEYS.PROJECT_PATHOLOGIES, urlParams.projectId],
        queryFn: () => httpGetPathologies({urlParams}),
        ...options
    })
